module.exports = __webpack_public_path__ + "assets/img/meeting-2026-link-reconvented.5249b644.webp";